<template>
  <div>
    <v-container class="all-height" fluid>
      <v-row no-gutters wrap>
        <v-col cols="12" sm="12" md="6">
          <player :url="audioUrl" :title="title" :author="author" />
        </v-col>
        <v-col class="info" cols="12" sm="12" md="6">
          <info />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import player from "@/components/player.vue";
import info from "@/components/info.vue";

export default {
  name: "campaign",
  props: ["audioUrl", "title", "author"],
  components: { player, info }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  padding: 0px;
  margin: 0px;
}

.container .info {
  background-color: white !important;
}
</style>
